import { useState } from "react";
import { toast } from "react-toastify";
import { api } from "../../config/api";
import { Select } from "antd";
import Modal from "react-modal";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getAdmins } from "../../lib/user";
import { useMyContext } from "../../context/MyContext";

const AddPersonalTodoModal = ({ setOpenModal, openModal }) => {
  const [loading, setLoading] = useState(false);
  const { user, token } = useMyContext();
  const queryClient = useQueryClient();
  const [data, setData] = useState({
    title: "",
    description: "",
    priority: null,
    date: "",
    dueDate: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAddData = async (e) => {
    try {
      setLoading(true);
      await api.post("/todos", { ...data, userId: user?.uid }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      queryClient.invalidateQueries(["personal-todos", user?.uid]);
      toast.success("Todo created successfully!");
      setOpenModal(false);
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : "Todo not added"
      );
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.79)",
      zIndex: 100,
    },
  };

  return (
    <Modal
      isOpen={openModal}
      onRequestClose={() => setOpenModal(false)}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div className="md:w-[500px] w-full">
        <h1 className="text-[#000] font-semibold text-[24px]">Add Todo</h1>

        <div className="mt-3 w-full">
          <input
            type="text"
            placeholder="Enter Todo Title"
            className="px-3 py-2  my-3 focus:outline-none w-full border rounded-lg  border-[#053F92] text-[rgba(5, 63, 146, 0.45)]"
            name="title"
            value={data.title}
            onChange={handleInputChange}
          />
          <input
            type="date"
            placeholder="Enter Todo Title"
            className="px-3 py-2  my-3 focus:outline-none w-full border rounded-lg  border-[#053F92] text-[rgba(5, 63, 146, 0.45)]"
            name="date"
            value={data.date}
            onChange={handleInputChange}
          />
          <input
            type="date"
            placeholder="Enter Todo Title"
            className="px-3 py-2  my-3 focus:outline-none w-full border rounded-lg  border-[#053F92] text-[rgba(5, 63, 146, 0.45)]"
            name="dueDate"
            value={data.dueDate}
            onChange={handleInputChange}
          />
          <Select
            options={[
              { label: "Urgent", value: "Urgent" },
              { label: "Medium", value: "Medium" },
              { label: "Normal", value: "Normal" },
            ]}
            onChange={(e) => setData({ ...data, priority: e })}
            className="w-full mt-2"
            placeholder="Priority"
            size="large"
          />
          <textarea
            type="text"
            placeholder="Enter Todo Description"
            className="px-3 py-2  my-3 focus:outline-none w-full border rounded-lg border-[#053F92] text-[rgba(5, 63, 146, 0.45)]"
            name="description"
            value={data.description}
            onChange={handleInputChange}
          />

          <div className="flex justify-center mt-1">
            <button
              type="submit"
              className="py-3 px-8 rounded-full bg-[#053F92] text-white"
              disabled={loading}
              onClick={handleAddData}
            >
              {loading ? "Adding..." : "Add Todo"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddPersonalTodoModal;
